const firebaseConfig = {
  apiKey: "AIzaSyB6EcBcM_AV_kNRXzQ4uPpCPl5odimV2yY",
  authDomain: "crypto-mania-d193f.firebaseapp.com",
  projectId: "crypto-mania-d193f",
  storageBucket: "crypto-mania-d193f.appspot.com",
  messagingSenderId: "506416247358",
  appId: "1:506416247358:web:7d3a63019289b5493a976f"
};

export default firebaseConfig;
